// Display-only exam-time formatting copied from Tarekmath. This never affects
// stored values, timezone handling, availability comparisons, or the countdown.

export function formatTime12(time) {
  if (time == null || time === '') return '';
  const parts = String(time).split(':');
  let h = parseInt(parts[0], 10);
  if (Number.isNaN(h)) return String(time);
  const m = String(parts[1] ?? '00').padStart(2, '0').slice(0, 2);
  const period = h < 12 ? 'ص' : 'م';
  let h12 = h % 12;
  if (h12 === 0) h12 = 12;
  return `${h12}:${m} ${period}`;
}
